import url from 'url';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import getRadioContext from '../routes/utils/getRadioContext';
import getVanitySlug from '../utils/guideItem/getVanitySlug';
import getRootCategorySlug from '../utils/guideItem/getRootCategorySlug';
import { isProfileInactive } from '../utils/profile';

import { PODCASTS_BROWSE_PATH } from '../constants/paths';

import {
  types as GuideItemTypes,
  isCategory,
  isType,
  matchGuideItemNumber,
} from '../utils/guideItemTypes';
import Error404 from './errors/404';
import ProfileLoader from './profile/ProfileLoader';
import BrowseLoader from './browse/BrowseLoader';

function determineRedirects(props) {
  const { location, match } = props;
  const { guideId } = getRadioContext(props);
  const isPodcast = get(match, 'params.podcastGuideIdentifier');
  if (isPodcast) {
    const isNumber = matchGuideItemNumber(guideId);
    if (!isNumber) {
      return url.format({
        pathname: PODCASTS_BROWSE_PATH,
        search: location.search,
      });
    }
  }

  const vanityRedirect = getVanitySlug(guideId);
  if (vanityRedirect) {
    return url.format({
      pathname: `/${vanityRedirect}/`,
      search: location.search,
    });
  }

  const rootCategoryRedirect = getRootCategorySlug(guideId);
  if (rootCategoryRedirect) {
    return url.format({
      pathname: `/${rootCategoryRedirect}/`,
      search: location.search,
    });
  }
  return null;
}

function RadioRoute(props) {
  const { guideId } = getRadioContext(props) || {};
  const route = determineRedirects(props);
  if (route) {
    props.history.replace(route);
    return null;
  }

  if (isCategory(guideId)) {
    return <BrowseLoader {...props} />;
  }

  if (
    isType(guideId, GuideItemTypes.station, GuideItemTypes.program) &&
    !isProfileInactive(guideId, props.profiles)
  ) {
    return <ProfileLoader {...props} />;
  }
  return <Error404 {...props} />;
}

RadioRoute.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  profiles: PropTypes.object.isRequired,
};

export default RadioRoute;
